var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "b-form",
        {
          class: [_vm.inline ? "gap-2 items-center" : ""],
          attrs: { inline: _vm.inline },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.onSubmit($event)
            },
            reset: [
              function($event) {
                $event.preventDefault()
                return _vm.clear($event)
              },
              _vm.onReset
            ]
          }
        },
        [
          _c(
            "b-form-group",
            {
              attrs: {
                id: "input-group-1",
                label: _vm.$t("document_title"),
                "label-for": "document_title"
              }
            },
            [
              _c("b-form-input", {
                staticClass: "required",
                attrs: { id: "document_title", disabled: "" },
                model: {
                  value: _vm.item.title,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "title", $$v)
                  },
                  expression: "item.title"
                }
              })
            ],
            1
          ),
          _c(
            "b-form-group",
            {
              attrs: {
                id: "input-group-2",
                label: _vm.$t("document_category"),
                "label-for": "document_category"
              }
            },
            [
              _c("b-form-select", {
                staticClass: "required-select",
                attrs: {
                  id: "document-category",
                  options: _vm.documentCategories,
                  "text-field": "name",
                  "value-field": "id",
                  disabled: ""
                },
                model: {
                  value: _vm.item.document_category_id,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "document_category_id", $$v)
                  },
                  expression: "item.document_category_id"
                }
              })
            ],
            1
          ),
          _c(
            "b-form-group",
            {
              attrs: {
                id: "input-group-3",
                label: _vm.$t("document_description"),
                "label-for": "document_description"
              }
            },
            [
              _c("div", {
                directives: [
                  {
                    name: "html-safe",
                    rawName: "v-html-safe",
                    value: _vm.item.description,
                    expression: "item.description"
                  }
                ],
                staticClass:
                  "simple-content simple-editor simple-editor-disabled"
              })
            ]
          ),
          _vm.item.password
            ? _c(
                "b-form-group",
                {
                  attrs: {
                    id: "input-group-4",
                    label: _vm.$t("document_password"),
                    "label-for": "document_password"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: { id: "document_password", disabled: "" },
                    model: {
                      value: _vm.item.password,
                      callback: function($$v) {
                        _vm.$set(_vm.item, "password", $$v)
                      },
                      expression: "item.password"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "b-row",
            { staticClass: "m-0" },
            [
              _c(
                "b-col",
                { attrs: { lg: "12" } },
                [
                  _c("h5", { staticClass: "mt-2 mb-0" }, [
                    _vm._v(_vm._s(_vm.$t("document_subtitle_document")))
                  ]),
                  _c("vs-divider")
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-row",
            {},
            [
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c("media-list", {
                    attrs: {
                      medias: _vm.files,
                      "show-delete": false,
                      "action-on-click": false
                    }
                  }),
                  _vm.files && _vm.files.length > 0
                    ? _c(
                        "div",
                        { staticClass: "flex flex-row justify-end pb-1" },
                        [
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "permission",
                                  rawName: "v-permission",
                                  value: "documents.download_all",
                                  expression: "'documents.download_all'"
                                }
                              ],
                              attrs: { variant: "primary" },
                              on: { click: _vm.downloadAll }
                            },
                            [
                              _c("feather-icon", {
                                staticClass: "mr-50",
                                attrs: { icon: "DownloadIcon" }
                              }),
                              _c("span", { staticClass: "align-middle" }, [
                                _vm._v(_vm._s(_vm.$t("action.download_all")))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.files || _vm.files.length == 0
                    ? _c(
                        "div",
                        { staticClass: "flex flex-row justify-center" },
                        [_vm._v(" " + _vm._s(_vm.$t("msg_none_file")) + " ")]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }